export var PixelStatus;
(function (PixelStatus) {
    PixelStatus[PixelStatus["Deleted"] = -1] = "Deleted";
    PixelStatus[PixelStatus["Active"] = 1] = "Active";
})(PixelStatus || (PixelStatus = {}));
export var PixelType;
(function (PixelType) {
    PixelType[PixelType["S2S"] = 1] = "S2S";
    PixelType[PixelType["IFrame"] = 2] = "IFrame";
    PixelType[PixelType["JS"] = 3] = "JS";
})(PixelType || (PixelType = {}));
export const PixelTypeMap = new Map([
    [PixelType.S2S, 'Global.Options.PixelType.S2S'],
    [PixelType.IFrame, 'Global.Options.PixelType.IFrame'],
    [PixelType.JS, 'Global.Options.PixelType.JS'],
]);
export var PixelActionTypeString;
(function (PixelActionTypeString) {
    PixelActionTypeString["OptIn"] = "opt-in";
    PixelActionTypeString["Lead"] = "lead";
    PixelActionTypeString["FTD"] = "ftd";
    PixelActionTypeString["Revshare"] = "revshare";
    PixelActionTypeString["Sale"] = "sale";
})(PixelActionTypeString || (PixelActionTypeString = {}));
export const PixelActionTypeStringMap = new Map([
    [PixelActionTypeString.Lead, 'Global.Options.Lead'],
    [PixelActionTypeString.FTD, 'Global.Options.FTD'],
]);
export const PixelActionTypeStringForInfoModalIdMap = new Map([
    [PixelActionTypeString.Lead, 'ActionInfoModal.Options.PixelActionTypeStringForActionInfoModalId.Lead'],
    [PixelActionTypeString.FTD, 'ActionInfoModal.Options.PixelActionTypeStringForActionInfoModalId.FTD'],
]);
export const PixelActionTypeStringForInfoModalDateMap = new Map([
    [PixelActionTypeString.OptIn, 'ActionInfoModal.Options.PixelActionTypeStringForActionInfoModalDate.OptIn'],
    [PixelActionTypeString.Lead, 'Grid.Header.LeadDate'],
    [PixelActionTypeString.FTD, 'Grid.Header.FTDDate'],
    [
        PixelActionTypeString.Revshare,
        'ActionInfoModal.Options.PixelActionTypeStringForActionInfoModalDate.Revshare',
    ],
    [PixelActionTypeString.Sale, 'Grid.Header.SaleDate'],
]);
export var CallbackMethod;
(function (CallbackMethod) {
    CallbackMethod["POST"] = "POST";
    CallbackMethod["GET"] = "GET";
})(CallbackMethod || (CallbackMethod = {}));
// this map is international words
export const CallbackMethodMap = new Map([
    [CallbackMethod.POST, 'POST'],
    [CallbackMethod.GET, 'GET'],
]);
export var CallbackActionType;
(function (CallbackActionType) {
    CallbackActionType["Lead"] = "LEAD";
    CallbackActionType["FTD"] = "FTD";
})(CallbackActionType || (CallbackActionType = {}));
export const CallbackActionTypeMap = new Map([
    [CallbackActionType.Lead, 'Global.Options.Lead'],
    [CallbackActionType.FTD, 'Global.Options.FTD'],
]);
